<template>
    <div class="inline-flex text-xs text-gray-800 p-0.5 bg-gray-100 rounded-full border border-gray-300 w-full" ref="menuBoundary">
      <div
        class="flex flex-row items-center justify-start h-full w-full"
      >
        <div class="flex flex-row items-center w-full justify-between ">
          <div class="flex flex-row items-center  w-full grow-0 min-w-0">
            <!-- <div
              v-if="showSelectAll"
              ref="selectAllBoundary"
              @mouseover="showToolTipPopover('selectAll', 'Select All')"
              @mouseleave="hideToolTipPopover"
              class="px-3.5 mr-2 flex flex-row grow-0 items-center border-r border-gray-300 h-6"
              >
              <SelectAll
                :selectAll="selectAll"
                @toggle-select-all="toggleSelectAll"
              />
            </div> -->
            <div
              v-if="showRefreshButton"
              class="px-1 border-r border-gray-300 "
              ref="refreshBoundary"
              @mouseover="showToolTipPopover('refresh', 'Refresh')"
              @mouseleave="hideToolTipPopover"
            >
              <PaginationLoader
                class="rounded-full hover:bg-gray-300 p-0.5"
                @refetch-results="refetchResults"
                :isLoading="isLoading"
              ></PaginationLoader>
            </div>
            <div v-if="showPaginationArrows" class="flex flex-row items-end pl-3.5">
              <PaginationArrows
                @get-next="getNext"
                @go-to-first="goToFirst"
                @get-prev="getPrev"
                @go-to-last="goToLast"
                @jump-to-page="jumpToPage"
                :page="page"
                :numPages="numPages"
                :has-next="hasNext"
                :has-prev="hasPrev"
              ></PaginationArrows>
            </div>
            <div  v-if="showTotalResults" class="pl-3 whitespace-nowrap">
              <div v-if="viewingFromNbr==viewingToNbr" class="whitespace-nowrap">
                Showing {{ viewingFromNbr }} ({{ count }} Total)
              </div>
              <div v-else class="whitespace-nowrap">
                Showing {{ viewingFromNbr }}-{{ viewingToNbr }} ({{ count }} Total)
              </div>
            </div>
            <div class="w-fit h-full flex border-r border-gray-300 pl-3 pr-1.5">
              <FilterCompactHorizontal class="mx-2" v-if="showPageSize">
                <template v-slot:label> Pg Size </template>
                <template v-slot:widget>
                  <ListBoxHorizontal
                    class="w-12 rounded-r-md text-xs text-black"
                    placeholder="Select"
                    :options="pageSizeOptions"
                    :modelValue="pageSizeFilter"
                    :multiple="false"
                    @update:modelValue="setPageSizeFilter"
                  />
                </template>
              </FilterCompactHorizontal>
            </div>
            <div
              v-if="showBulkOperations"
              class="h-full px-2 flex border-r border-gray-300"
            >
              <div
                class="rounded-md hover:bg-gray-300 p-1 hover:cursor-pointer"
                @click="toggleBulkOperations"
                ref="bulkOperationsBoundary"
                @mouseover="showToolTipPopover('bulkOperations', 'Bulk Operations')"
                @mouseleave="hideToolTipPopover"
              >
                <BulkOperationSVG />
              </div>
            </div>
            <div v-if="showFilters" class="w-full h-full flex min-w-0 ml-2">
              <div
                :style="filterFormat"
                class="rounded-md hover:bg-gray-300 p-1.5 mr-2 hover:cursor-pointer"
                @click="toggleFilters"
                ref="filterBoundary"
                @mouseover="showToolTipPopover('filter', 'Filter')"
                @mouseleave="hideToolTipPopover"
              >
                  <FilterSVG />
              </div>
              <div v-if="activeFilters.length > 0 & !visibleActiveFilters"
                @click="showActiveFilters"
                class="rounded-md hover:bg-amber-300 px-1.5 py-1 h-full hover:cursor-pointer "
                ref="activeFiltersBoundary"
                @mouseover="showToolTipPopover('activeFilters', 'Active Filters')"
                @mouseleave="hideToolTipPopover"
              >
                  >
                </div>
              <div v-show="visibleActiveFilters" class="pl-2 flex w-full grow-0 items-center border-l border-gray-300 overflow-x-scroll">
                <ActiveFilters
                  :active-filters="activeFilters"
                  @clear-filter="clearFilter"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-row justify-end pr-1.5 pl-2" v-if="showQuickBulkButtons">
            <button @click="executeQuickBulkAction(quickBulk.bulkAction)" v-for="quickBulk in menuOptions.quickBulkButtons" :disabled="selectedResults.length < 1" :class="{'bg-gray-400 text-black' : selectedResults.length < 1, 'bg-dark-primary text-white hover:shadow-md active:bg-dark-secondary' : selectedResults.length > 0}" :key="quickBulk.label" class="rounded-md py-0.5 px-1 whitespace-nowrap">
              {{ quickBulk.label }}
            </button>
          </div>
          <div
            v-if="showAddFormRows"
            class="flex flex-row justify-end pr-1.5 pl-2 border-l border-gray-300"
            ref="addFormRowsBoundary"
              @mouseover="showToolTipPopover('addFormRows', 'Add New')"
              @mouseleave="hideToolTipPopover"
          >
            <button @click="addFormRow" class="rounded-full bg-dark-primary text-white py-0.5 px-1 hover:shadow-md active:bg-dark-secondary">
              +
            </button>
            <!-- add new service record button -->
          </div>
          <div
            v-if="showAddModal"
            class="flex flex-row justify-end pr-1.5 pl-2 border-l border-gray-300"
            ref="addModalBoundary"
              @mouseover="showToolTipPopover('addModal', 'Add New')"
              @mouseleave="hideToolTipPopover"
          >
            <button @click="openAddModal" class="rounded-full bg-dark-primary text-white py-0.5 px-1 hover:shadow-md active:bg-dark-secondary">
              +
            </button>
            <!-- add new service record button -->
          </div>
        </div>
      </div>
      <div>
        <base-tool-tip
          v-if="visibleToolTipPopover"
          :xPosition="xPosition"
          :yPosition="yPosition"
        >
          <template #title>
            {{ toolTipText }}
          </template>
        </base-tool-tip>
        <PopoverClick
              v-show="visibleFilters"
              :xPosition="xPosition"
              :yPosition="yPosition"
              class="mr-14 shadow-md rounded-md border border-gray-300"
          >
              <FilterSet 
                :filters="filters"
                @change-filters="changeFilters"
                @change-active-filters="setActiveFilters"
                @change-ordering="setOrder"
                @set-filter-options="setFilterOptions"
                @hide-active-filters="hideActiveFilters"
                @clear-select-all="clearSelectAll"
              />
          </PopoverClick>
          <PopoverClick
              v-show="visibleBulkOperations"
              :xPosition="xPosition"
              :yPosition="yPosition"
              class="mr-14 shadow-md rounded-md border border-gray-300"
          >
            <BulkOperationButtons
              :selectedResults="selectedResults"
              :filters="filters"
              :bulkOperations="bulkOperations"
              :userPermissions="userPermissions"
              @refetch-results="refetchResults"
              @clear-selected-results="clearSelectedResults"
              @reset-select-all="resetSelectAll"
              @close="hideBulkOperations"
            >
            <template #bulk-operations="{ events: { hideBulkActionMenu },  bulkAction, selectedResults }">
                <slot name="bulk-operations"
                    :selectedResults="selectedResults"
                    :bulkAction="bulkAction"
                    :events="{ hideBulkActionMenu, hideBulkOperations }"
                ></slot>
              </template>
            </BulkOperationButtons>
          </PopoverClick>
        </div>
    </div>
  </template>
  
  <script setup>  
  import { ref, defineEmits, defineProps, watch, computed } from "vue";
  // import SelectAll from "./SelectAll.vue";
  import PaginationLoader from "./PaginationLoader.vue";
  import PaginationArrows from "./PaginationArrows.vue";
  import FilterCompactHorizontal from "./FilterCompactHorizontal.vue";
  import ListBoxHorizontal from "./ListBoxHorizontal.vue";
  import ActiveFilters from "./ActiveFilters.vue";
  import PopoverClick from './PopoverClick.vue';
  import FilterSVG from "@/components/svg-components/FilterSVG.vue";
  import BulkOperationSVG from '@/components/svg-components/BulkOperationSVG.vue';
  import FilterSet from "./FilterSet.vue";
  import BulkOperationButtons from '@/components/base-components/BulkOperationButtons.vue';
  import { useClickOutside } from "@/composables/useClickOutside";
  
  const props = defineProps([
    "isLoading",
    "page",
    "numPages",
    "pageFilter",
    "filters",
    "selectAll",
    "menuOptions",
    "selectedResults",
    "bulkOperations",
    "userPermissions",
    "count",
    "orderBy",
    "viewingFromNbr",
    "viewingToNbr",
    "defaultPageSize",
    "hasNext",
    "hasPrev"
  ]);

  const emit = defineEmits([
    "get-next",
    "refetch-results",
    "go-to-first",
    "get-prev",
    "go-to-last",
    "jump-to-page",
    "set-page-size-filter",
    "toggle-filter-set",
    "clear-filter",
    "change-filters",
    "change-ordering",
    "toggle-select-all",
    "set-filter-options",
    "add-form-row",
    "clear-select-all",
    "do-quick-bulk",
    "open-add-modal"
  ]);

  function executeQuickBulkAction(bulkActionName) {
    emit('do-quick-bulk', bulkActionName)
  }
  
  const pageSizeFilter = ref(props.defaultPageSize ? props.defaultPageSize : 50);
  const pageSizeOptions = ref([
    { value: "clear", label: "--" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 200, label: "200" },
  ]);
  const activeFilters = ref([]);
  const visibleBulkOperations = ref(false);
  const visibleFilters = ref(false);
  const visibleActiveFilters = ref(true);
  const filterBoundary = ref(null);
  const menuBoundary = ref(null);
  const selectAllBoundary = ref(null);
  const refreshBoundary = ref(null);
  const bulkOperationsBoundary = ref(null);
  const activeFiltersBoundary = ref(null);
  const addFormRowsBoundary = ref(null);
  const addModalBoundary = ref(null);
  const xPosition = ref(0);
  const yPosition = ref(0);
  const visibleToolTipPopover = ref(false);
  const toolTipText = ref(null);
  
  // watchers
  
  watch(props.pageFilter, () => {
    if (props.pageFilter.pageSizeFilter) {
      pageSizeFilter.value = props.pageFilter.pageSizeFilter;
    } else {
      pageSizeFilter.value = 50;
    }
    
  });

  watch(activeFilters.value, ()=> {
    // console.log('active filters changed')
  }, {deep: true})

  const filterFormat = computed(() => {
    if(visibleFilters.value) {
      return 'background-color: #D1D5DB;'
    } else {
      if(activeFilters.value.length > 0) {
        return 'background-color: #FCD34D;'
      } else{
        return ''
      }
    }

  })

  const showSelectAll = computed(() => {
    if(props.menuOptions) {
      if('selectAll' in props.menuOptions){
        if(!props.menuOptions.selectAll) {
          return false
        }
      }
    }
    return true
  })

  const showPaginationArrows = computed(() => {
    if(props.menuOptions) {
      if('paginationArrows' in props.menuOptions){
        if(!props.menuOptions.paginationArrows) {
          return false
        }
      }
    }
    return true
  })

  const showPageSize = computed(() => {
    if(props.menuOptions) {
      if('pageSize' in props.menuOptions){
        if(!props.menuOptions.pageSize) {
          return false
        }
      }
    }
    return true
  })

  const showTotalResults = computed(() => {
    if(props.menuOptions) {
      if('totalResults' in props.menuOptions) {
        if(!props.menuOptions.totalResults) {
          return false
        }
      }
    }
    return true
  })

  const showRefreshButton = computed(() => {
    if(props.menuOptions) {
      if('refreshButton' in props.menuOptions){
        if(!props.menuOptions.refreshButton) {
          return false
        }
      }
    }
    return true
  })

  const showFilters = computed(() => {
    if(props.menuOptions) {
      if('filters' in props.menuOptions){
        if(!props.menuOptions.filters) {
          return false
        }
      }
    }
    return true
  })

  const showBulkOperations = computed(() => {
    if(props.menuOptions) {
      if('bulkOperations' in props.menuOptions){
        if(!props.menuOptions.bulkOperations) {
          return false
        }
      }
    }
    return true
  })

  const showAddFormRows = computed(() => {
    if(props.menuOptions) {
      if('addFormRows' in props.menuOptions){
        if(!props.menuOptions.addFormRows) {
          return false
        }
      }
    }
    return true
  })

  const showAddModal = computed(() => {
    if(props.menuOptions) {
      if('addModal' in props.menuOptions){
        if(!props.menuOptions.addModal) {
          return false
        }
      } else {
        return false
      }
    }
    return true
  })

  const showQuickBulkButtons = computed(() => {
    if(props.menuOptions) {
      if('quickBulkButtons' in props.menuOptions ){
        if(props.menuOptions.quickBulkButtons.length > 0) {
          return true
        }
      }
    }
    return false
  })

  function showToolTipPopover(elementName, text) {
    if(!visibleFilters.value & !visibleBulkOperations.value) {
      if(elementName == 'selectAll') {
        // console.log('selectAll')
        xPosition.value = selectAllBoundary.value.getBoundingClientRect().right
        yPosition.value = selectAllBoundary.value.getBoundingClientRect().bottom
      } else if (elementName == 'refresh'){
        // console.log('refresh')
        xPosition.value = refreshBoundary.value.getBoundingClientRect().right
        yPosition.value = refreshBoundary.value.getBoundingClientRect().bottom
      } else if (elementName == 'bulkOperations') {
        // console.log('bulkOPerations')
        xPosition.value = bulkOperationsBoundary.value.getBoundingClientRect().right
        yPosition.value = bulkOperationsBoundary.value.getBoundingClientRect().bottom
      } else if (elementName == 'filter') {
        // console.log('filter')
          xPosition.value = filterBoundary.value.getBoundingClientRect().right
          yPosition.value = filterBoundary.value.getBoundingClientRect().bottom
      } else if (elementName == 'activeFilters') {
        // console.log('activeFilters')
        if(!visibleActiveFilters.value) {
          xPosition.value = activeFiltersBoundary.value.getBoundingClientRect().right
          yPosition.value = activeFiltersBoundary.value.getBoundingClientRect().bottom
        } else {
          return
        }
      } else if (elementName == 'addFormRows') {
        // console.log('addformrows')
        xPosition.value = addFormRowsBoundary.value.getBoundingClientRect().left
        yPosition.value = addFormRowsBoundary.value.getBoundingClientRect().bottom
      } else if (elementName == 'addModal') {
        // console.log('addModal')
        xPosition.value = addModalBoundary.value.getBoundingClientRect().left
        yPosition.value = addModalBoundary.value.getBoundingClientRect().bottom
      }
      visibleToolTipPopover.value = true;
      toolTipText.value = text;
    }
  }

  function hideToolTipPopover() {
    visibleToolTipPopover.value = false;
    toolTipText.value = null;
  }

  function refetchResults() {
    emit("refetch-results");
  }
  
  function getNext() {
    emit("get-next");
  }
  
  function goToFirst() {
    emit("go-to-first");
  }
  
  function getPrev() {
    emit("get-prev");
  }
  
  function goToLast() {
    emit("go-to-last");
  }
  
  function jumpToPage(targetPage) {
    emit("jump-to-page", targetPage);
  }
  
  function setPageSizeFilter(pageSize) {
    // console.log('setPageSizeFilter')
    // console.log(pageSize)
    emit("set-page-size-filter", pageSize);
  }

  function toggleSelectAll() {
    emit('toggle-select-all')
  }

  function resetSelectAll() {

  }

  function clearSelectedResults() {

  }

  function toggleFilters() {
    if(!visibleFilters.value){
      visibleBulkOperations.value = false
      visibleFilters.value = true
      xPosition.value = filterBoundary.value.getBoundingClientRect().left + 6
      yPosition.value = filterBoundary.value.getBoundingClientRect().bottom - 5
      hideToolTipPopover()
    } else {
        hideFilters()
    }
  }

  function toggleBulkOperations() {
    if(!visibleBulkOperations.value) {
      visibleFilters.value = false
      visibleBulkOperations.value = true
      xPosition.value = bulkOperationsBoundary.value.getBoundingClientRect().left
      yPosition.value= bulkOperationsBoundary.value.getBoundingClientRect().bottom
      hideToolTipPopover()
    } else {
      hideBulkOperations()
    }
  }

  useClickOutside(menuBoundary, () => {
    if(visibleFilters.value) {
      hideFilters()
    }
    if(visibleBulkOperations.value) {
      hideBulkOperations()
    }
  })

  function hideFilters() {
      visibleFilters.value = false
  }

  function hideBulkOperations() {
    visibleBulkOperations.value = false
  }

  function showActiveFilters() {
    visibleActiveFilters.value = true
    hideToolTipPopover()
  }

  function hideActiveFilters() {
      visibleActiveFilters.value = false
  }

  function clearFilter(filterName) {
    emit('clear-filter', filterName)
  }

  function changeFilters(filters) {
      emit('change-filters', filters)
  }

  function setActiveFilters(filters) {
      // console.log('setActiveFilters')
      // console.log(filters)
      activeFilters.value = filters
  }

  function setFilterOptions(filter) {
    emit('set-filter-options', filter)
  }

  function setOrder() {
      // console.log('setOrder')
  }

  function addFormRow() {
    emit('add-form-row')
  }

  function openAddModal() {
    emit('open-add-modal')
  }

function clearSelectAll() {
  emit('clear-select-all')
}

  </script>

<style scoped>
  ::-webkit-scrollbar{
      height: 0px;
      width: 0px;
  }
  ::-webkit-scrollbar-thumb:horizontal{
      background: #D1D5DB;
      border-radius: 3px;
  }
</style>